var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-16"},[_c('p',{staticClass:"text-h5 text-center white--text"},[_vm._v("会員登録が完了しました")]),_c('p',{staticClass:"text-subtitle-1 text-center white--text"},[_vm._v("ログインしてArcaraをお楽しみください")]),_c('v-row',{staticClass:"mt-10",attrs:{"justify":"center"}},[_c('v-btn',{attrs:{"to":"login"}},[_vm._v("ログイン")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }